import React, { useMemo } from "react";
import { AdminProductOption } from "../../../services/platformApi";
import ProductStatusChip from "./ProductStatusChip";

interface ProductMultiSelectDropdownProps {
  availableProducts: AdminProductOption[];
  selectedProducts: string[];
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onToggleProduct: (productKey: string) => void;
  productCertificationStatuses?: Record<string, boolean>;
  showCertificationStatus?: boolean;
}

const ProductMultiSelectDropdown: React.FC<ProductMultiSelectDropdownProps> = ({
  availableProducts,
  selectedProducts,
  isOpen,
  onOpenChange,
  onToggleProduct,
  productCertificationStatuses,
  showCertificationStatus = false,
}) => {
  const selectedEntries = useMemo(
    () =>
      availableProducts
        .filter((product) => selectedProducts.includes(product.key))
        .map((product) => {
          const certificationStatus = productCertificationStatuses?.[product.key];

          return {
            key: product.key,
            title: product.title,
            isCertified:
              typeof certificationStatus === "boolean" ? certificationStatus : undefined,
          };
        }),
    [availableProducts, productCertificationStatuses, selectedProducts]
  );

  return (
    <div className="admin-page__dropdown">
      <button
        type="button"
        className="admin-page__dropdown-trigger"
        onClick={() => onOpenChange(!isOpen)}
      >
        <span>
          {selectedProducts.length > 0
            ? `Pasirinkta produktų: ${selectedProducts.length}`
            : "Pasirinkite produktus"}
        </span>
        <span className={`admin-page__dropdown-arrow ${isOpen ? "is-open" : ""}`}>▾</span>
      </button>

      {selectedEntries.length > 0 && (
        <div className="admin-page__chips">
          {selectedEntries.map((product) => (
            <ProductStatusChip
              key={product.key}
              title={product.title}
              isCertified={product.isCertified}
              showCertificationStatus={showCertificationStatus}
            />
          ))}
        </div>
      )}

      {isOpen && (
        <div className="admin-page__dropdown-panel">
          <div className="admin-page__product-grid">
            {availableProducts.map((product) => (
              <label key={product.key} className="admin-page__product-option">
                <input
                  type="checkbox"
                  checked={selectedProducts.includes(product.key)}
                  onChange={() => onToggleProduct(product.key)}
                />
                <span>
                  <strong>{product.key}</strong>
                  <small>{product.title}</small>
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductMultiSelectDropdown;
